import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/EditorFields';

import { HomepageBadgeType } from '../model/skill';

const t = i18n(keyset);

export const EDITOR_FIELDS_BADGES = [
    {
        value: HomepageBadgeType.Kids,
        label: t('badge-kids'),
    },
    {
        value: HomepageBadgeType.New,
        label: t('badge-new'),
    },
    {
        value: HomepageBadgeType.Puzzle,
        label: t('badge-puzzle'),
    },
    {
        value: HomepageBadgeType.Quest,
        label: t('badge-quest'),
    },
    {
        value: HomepageBadgeType.AliceChoice,
        label: t('badge-alice-choice'),
    },
    {
        value: HomepageBadgeType.Helpful,
        label: t('badge-helpful'),
    },
    {
        value: HomepageBadgeType.Sport,
        label: t('badge-sport'),
    },
    {
        value: HomepageBadgeType.Interesting,
        label: t('badge-interesting'),
    },
    {
        value: HomepageBadgeType.Wonderful,
        label: t('badge-wonderful'),
    },
    {
        value: HomepageBadgeType.Tasty,
        label: t('badge-tasty'),
    },
] as const;

export const EDITOR_FIELDS_TAGS = [
    'kids',
    'game',
    'new',
    'smarthome',
    'quest',
    'internal',
    'external',
    'sport',
    'health',
    'puzzle',
    'education',
    'buy',
    'finance',
    'travel',
    'productivity',
    'help',
    'everyday',
    'auto',
    'video',
    'audio',
    'news',
    'culture',
] as const;

export function removeDuplicatesUnordered<T>(arr: T[]) {
    return Array.from(new Set(arr));
}
